import React, { useEffect, useState } from 'react';
import { Box, Card, CardActionArea, CardContent, CardMedia, Grid, Typography } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import CategoryIcon from '@mui/icons-material/Category';
import { useNavigate } from 'react-router-dom';
import agent from '../../agent';
import { DEFAULT_THEME_COLOR } from '../../constants/theme';

const GarageSection = ({ username, context, isOwnProfile, strings }) => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let active = true;
    agent.FreakItems.all(context, isOwnProfile ? undefined : username)
      .then((res) => { if (active) { setItems(res.freakItems || []); setLoaded(true); } })
      .catch(() => { if (active) setLoaded(true); });
    return () => { active = false; };
  }, [username, context, isOwnProfile]);

  if (loaded && !items.length && !isOwnProfile) {
    return null;
  }

  return (
    <Box sx={{ mt: 3, px: { xs: 1, sm: 0 } }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1.5 }}>
        {strings.freakItems.title}
      </Typography>
      <Grid container spacing={1.5}>
        {items.map((item) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={item.slug}>
            <Card sx={{ borderRadius: 2 }}>
              <CardActionArea onClick={() => navigate(`/freak-items/${item.slug}`)}>
                {item.imageUrl
                  ? <CardMedia component="img" height="140" image={item.imageUrl} alt={item.name}/>
                  : <Box sx={{ height: 140, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <CategoryIcon sx={{ fontSize: 56, color: DEFAULT_THEME_COLOR }}/>
                  </Box>}
                <CardContent sx={{ py: 1.5 }}>
                  <Typography variant="subtitle2" sx={{ fontWeight: 700 }} noWrap>{item.name}</Typography>
                  <Typography variant="caption" color="text.secondary" noWrap>
                    {[item.brand, item.model, item.category?.name].filter(Boolean).join(' · ')}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
        {isOwnProfile && (
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Card sx={{ borderRadius: 2, height: '100%', minHeight: 200 }}>
              <CardActionArea
                sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
                onClick={() => navigate('/freak-items-editor')}
              >
                <AddCircleOutlineIcon sx={{ fontSize: 48, color: DEFAULT_THEME_COLOR }}/>
                <Typography variant="subtitle2" sx={{ mt: 1 }}>{strings.freakItems.add}</Typography>
              </CardActionArea>
            </Card>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default GarageSection;
